import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Table, Form, InputGroup, Button, Row, Col } from 'react-bootstrap';
import { FaSearch, FaPlus, FaFileDownload, FaShare } from 'react-icons/fa';
import { generateInvoicePDF } from '../utils/pdfGenerator';

function InvoiceList() {
  // Mock data - replace with actual data fetching
  const [invoices] = useState([
    {
      id: 'INV-001',
      client: 'Acme Construction',
      jobSite: '123 Main St',
      jobCode: 'AC-001',
      amount: '$2,400',
      status: 'Pending',
      date: '2024-05-22'
    },
    {
      id: 'INV-002',
      client: 'BuildRight Inc',
      jobSite: '456 Oak Ave',
      jobCode: 'BR-001',
      amount: '$1,850',
      status: 'Paid',
      date: '2024-05-21'
    },
    {
      id: 'INV-003',
      client: 'Metro Builders',
      jobSite: '789 Pine St',
      jobCode: 'MB-001',
      amount: '$3,200',
      status: 'Pending',
      date: '2024-05-20'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  const filteredInvoices = invoices.filter((invoice) => {
    const matchesSearch =
      invoice.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.jobSite.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.jobCode.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      filterStatus === 'all' || invoice.status.toLowerCase() === filterStatus.toLowerCase();

    return matchesSearch && matchesStatus;
  });

  const handleDownload = (invoiceId) => {
    const invoice = invoices.find(inv => inv.id === invoiceId);
    if (invoice) {
      const doc = generateInvoicePDF(invoice);
      doc.save(`invoice-${invoice.id}.pdf`);
    }
  };

  const handleShare = (invoiceId) => {
    // TODO: Implement sharing functionality
    console.log('Sharing invoice:', invoiceId);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3 mb-0">Invoices</h1>
        <Button
          as={Link}
          to="/invoices/new"
          variant="primary"
          className="d-flex align-items-center"
        >
          <FaPlus className="me-2" /> Create Invoice
        </Button>
      </div>

      <Card className="mb-4">
        <Card.Body>
          <Row className="g-3">
            <Col md={8}>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Search invoices..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="paid">Paid</option>
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="mb-0">
              <thead>
                <tr>
                  <th>Invoice #</th>
                  <th>Client</th>
                  <th>Job Site</th>
                  <th>Job Code</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>
                      <Link to={`/invoices/${invoice.id}`} className="text-primary fw-medium">
                        {invoice.id}
                      </Link>
                    </td>
                    <td>{invoice.client}</td>
                    <td>{invoice.jobSite}</td>
                    <td>{invoice.jobCode}</td>
                    <td>{invoice.amount}</td>
                    <td>
                      <span className={`status-badge ${invoice.status.toLowerCase()}`}>
                        {invoice.status}
                      </span>
                    </td>
                    <td>{invoice.date}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <Button
                          variant="link"
                          className="p-0 text-primary"
                          onClick={() => handleDownload(invoice.id)}
                          title="Download PDF"
                        >
                          <FaFileDownload />
                        </Button>
                        <Button
                          variant="link"
                          className="p-0 text-primary"
                          onClick={() => handleShare(invoice.id)}
                          title="Share Invoice"
                        >
                          <FaShare />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default InvoiceList; 